<template lang="jade">
  div.Form__group(":tooltip"="fdata.tip")
    h3.Form__legend(v-if="fdata.legend || fdata.label") {{ fdata.legend || fdata.label }}
    component(
      v-for="field in fdata.content"
      ":is"="field.type"
      ":fdata.sync"="field"
     )
</template>

<script>
  import type_column from 'src/components/containers/columns'

  export default{
    data () {
      return {
        uid: this.$parent.uid
      }
    },
    props: ['fdata'],
    components: {
      type_column
    }
  }
</script>



// WEBPACK FOOTER //
// subFieldset.vue?35225b94